module.exports = __webpack_public_path__ + "img/f1c1703.jpg";